/* istanbul ignore file */

export const HEADING = 'Customers’ photos';
export const CONTROLS_LABEL = 'Carousel controls';
export const PREVIOUS_LABEL = 'Previous photos';
export const NEXT_LABEL = 'Next photos';
